import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/enable-cash-collection/';

type EnableParkingCashCollectionFnType = typeof enableParkingCashCollection;

type DTO = {
    parkingId: string;
};

const enableParkingCashCollection = ({ parkingId, ...data }: DTO): Promise<string> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseEnableParkingCashCollectionOptions
    extends MutationConfig<EnableParkingCashCollectionFnType, GeneralSmartParkError> {}

const useEnableParkingCashCollection = (options: UseEnableParkingCashCollectionOptions = {}) =>
    useMutation({
        mutationFn: enableParkingCashCollection,
        ...options,
    });

export { useEnableParkingCashCollection, enableParkingCashCollection, RESOURCE };
